export default __webpack_public_path__ + "static/media/Union.7389e099.png";